import 'ol/ol.css';
import ImageLayer from 'ol/layer/Image';
import Map from 'ol/Map';
import Projection from 'ol/proj/Projection';
import Static from 'ol/source/ImageStatic';
import View from 'ol/View';
import { getCenter } from 'ol/extent';
import XYZ from 'ol/source/XYZ';
import { FullScreen, Control, defaults as defaultControls } from 'ol/control';
import {DragRotate, defaults as defaultInteractions} from 'ol/interaction';
import {shiftKeyOnly} from 'ol/events/condition';



var homeMapSource = window.homeMapSource;

if (!homeMapSource) homeMapSource = [];

jQuery(document).ready(function($) {
    //console.log(homeMapSource);



    //var allImgs = [];
    homeMapSource.forEach(function(singleGroup, index) {
        if (!singleGroup.images.length) return;
        //allImgs.push(...singleGroup.images);
        singleGroup.cordinate = {
            x: null,
            y: null,
            angle: null
        };

        singleGroup.images.forEach(function(singleImage, index) {
            singleImage.cordinate = {
                x: null,
                y: null,
                angle: null
            }
        });
        evaluateImageDisposition(singleGroup)
    });
    /*
    allImgs.forEach(function(image, index)  {
        
        while (collapsOn(image, index, allImgs)) {
            console.log('Collision for ' + image.data[0]);
            image.cordinate.radius += (image.cordinate.radius / 10);
            setRelativeImagePosition(image);
        }
    });
    */

    evaluateGroupDisposition(homeMapSource);
    evaluateAbsolutePosition(homeMapSource);
    //console.log(homeMapSource);

    plotOnMap(homeMapSource);


    var W = window.innerWidth;
    var H = window.innerHeight;



    function evaluateImageDisposition(group) {
        console.group('Group ' + group.group.name + " w:" + group.images.length + " images");
        //Determino gli angoli
        let startAngle = getRandomInt(0, 360);
        let imageCount = group.images.length;
        let angleStep = 360 / imageCount;
        group.images.forEach(function(singleImage, index) {

            console.group('Image  ' + index + " " + singleImage.data[0]);

            singleImage.cordinate.angle = startAngle + (angleStep * index);
            singleImage.cordinate.angle = singleImage.cordinate.angle % 360;
            singleImage.cordinate.stepAngle = angleStep;


            scaleImage(singleImage);

            singleImage.cordinate.radius = Math.random() * calculateCircumscribedRadius(singleImage.data[1], singleImage.data[2]) / 2;

            setRelativeImagePosition(singleImage);

            while (collapsOn(singleImage, index, group.images)) {
            //     //console.log('Collision for ' + singleImage.data[0]);
            //     //console.log('Collision for ' + singleImage.data[0]);
                singleImage.cordinate.radius += (singleImage.cordinate.radius / 10);
                setRelativeImagePosition(singleImage);
            }

            console.groupEnd();


        });

        //console.log('Finisced single image process. Calulating group dimension');
        //evaluate group size
        group.cordinate.maxLeft = 0;
        group.cordinate.maxRight = 0;
        group.cordinate.maxTop = 0;
        group.cordinate.maxBottom = 0;

        group.images.forEach(function(singleImage, index) {

            let r = singleImage.cordinate.x + (singleImage.data[1] / 2);
            let l = singleImage.cordinate.x - (singleImage.data[1] / 2);

            let t = singleImage.cordinate.y + (singleImage.data[2] / 2);
            let b = singleImage.cordinate.y - (singleImage.data[2] / 2);

            if (group.cordinate.maxLeft > l) group.cordinate.maxLeft = l;
            if (group.cordinate.maxRight < r) group.cordinate.maxRight = r;
            if (group.cordinate.maxTop < t) group.cordinate.maxTop = t;
            if (group.cordinate.maxBottom > b) group.cordinate.maxBottom = b;
        });


        group.cordinate.w = Math.abs(group.cordinate.maxRight - group.cordinate.maxLeft);
        group.cordinate.h = Math.abs(group.cordinate.maxTop - group.cordinate.maxBottom);
        //console.log(group.cordinate);
        console.groupEnd();

    }


    function setRelativeImagePosition(singleImage) {
        //console.log('Setting relative group position..');
        singleImage.cordinate.x = Math.floor(Math.cos(degrees_to_radians(singleImage.cordinate.angle)) * singleImage.cordinate.radius);
        singleImage.cordinate.y = Math.floor(Math.sin(degrees_to_radians(singleImage.cordinate.angle)) * singleImage.cordinate.radius);

        // let x0 = singleImage.cordinate.x - (singleImage.data[1] / 2);
        // let x1 = singleImage.cordinate.x + (singleImage.data[1] / 2);
        // let y0 = singleImage.cordinate.y - (singleImage.data[2] / 2);
        // let y1 = singleImage.cordinate.y + (singleImage.data[2] / 2);
        // stessa cosa ma in diverso formato
        singleImage.cordinate.p1 = {
            x: singleImage.cordinate.x - (singleImage.data[1] / 2) + 20,
            y: singleImage.cordinate.y - (singleImage.data[2] / 2) + 20
        }
        singleImage.cordinate.p2 = {
            x: singleImage.cordinate.x + (singleImage.data[1] / 2)+ 20,
            y: singleImage.cordinate.y + (singleImage.data[2] / 2)+ 20
        }

        // singleImage.cordinate.relativeExtent = [x0, y0, x1, y1];
        //console.log(singleImage.cordinate);
    }








    function evaluateGroupDisposition(groupList) {


        let startAngle = getRandomInt(0, 360);
        let groupCount = groupList.length;
        let angleStep = 360 / groupCount;

        groupList.forEach(function(singleGroup, index) {
            singleGroup.cordinate.angle = startAngle + (angleStep * index);
            singleGroup.cordinate.angle = singleGroup.cordinate.angle % 360;
            singleGroup.cordinate.stepAngle = angleStep;



            // if (index == 0) {
            //     singleGroup.cordinate.radius = Math.random() * calculateCircumscribedRadius(singleGroup.cordinate.w, singleGroup.cordinate.h);
            // } else {
            //     singleGroup.cordinate.radius = (Math.random()+0.5) * calculateCircumscribedRadius(singleGroup.cordinate.w, singleGroup.cordinate.h) ;
            // }
            // singleGroup.cordinate.radius = ( Math.random() + 1 ) * calculateCircumscribedRadius(singleGroup.cordinate.w, singleGroup.cordinate.h);
            singleGroup.cordinate.radius = (Math.random() + 0.4) * calculateCircumscribedRadius(singleGroup.cordinate.w, singleGroup.cordinate.h);

            singleGroup.cordinate.x = Math.floor(Math.cos(degrees_to_radians(singleGroup.cordinate.angle)) * singleGroup.cordinate.radius);
            singleGroup.cordinate.y = Math.floor(Math.sin(degrees_to_radians(singleGroup.cordinate.angle)) * singleGroup.cordinate.radius);
            console.log('Checking ', singleGroup);

            while (collapsOnGroup(singleGroup, index, groupList)) {
                console.log('Collision for ', singleGroup);
                singleGroup.cordinate.radius += (singleGroup.cordinate.radius / 10);

                singleGroup.cordinate.x = Math.floor(Math.cos(degrees_to_radians(singleGroup.cordinate.angle)) * singleGroup.cordinate.radius);
                singleGroup.cordinate.y = Math.floor(Math.sin(degrees_to_radians(singleGroup.cordinate.angle)) * singleGroup.cordinate.radius);
            }

        });

    }



    function evaluateAbsolutePosition(groupList) {

        groupList.forEach(function(singleGroup, index) {
            singleGroup.images.forEach(function(singleImage, index) {
                singleImage.cordinate.absX = singleImage.cordinate.x + singleGroup.cordinate.x;
                singleImage.cordinate.absY = singleImage.cordinate.y + singleGroup.cordinate.y;
                singleImage.cordinate.mapX = convertCordinate(singleImage.cordinate.absX);
                singleImage.cordinate.mapY = convertCordinate(singleImage.cordinate.absY);

                singleImage.cordinate.mapW = convertCordinate(singleImage.data[1]);
                singleImage.cordinate.mapH = convertCordinate(singleImage.data[2]);

                let x0 = singleImage.cordinate.mapX - (singleImage.cordinate.mapW / 2);
                let x1 = singleImage.cordinate.mapX + (singleImage.cordinate.mapW / 2);
                let y0 = singleImage.cordinate.mapY - (singleImage.cordinate.mapH / 2);
                let y1 = singleImage.cordinate.mapY + (singleImage.cordinate.mapH / 2);

                singleImage.cordinate.extent = [x0, y0, x1, y1];




            });
        });

    }


    function scaleImage(singleImage) {
        const imageW = 1500;
        const imageH = 1500;


        let version = singleImage.data[1] > singleImage.data[2] ? "L" : "P";

        switch (version) {
            case 'L':
                var oldW = singleImage.data[1];
                var scale = imageW / singleImage.data[1];
                singleImage.data[1] = imageW;
                singleImage.data[2] = Math.floor(singleImage.data[2] * scale);
                //console.log('L Scale ratio ' + scale + " for " + singleImage.data[1] + " " + singleImage.data[2]);
                break;
            case 'P':
                var oldH = singleImage.data[2];
                var scale = imageH / singleImage.data[2];
                singleImage.data[2] = imageH;
                singleImage.data[1] = Math.floor(singleImage.data[1] * scale);
                //console.log('P Scale ratio ' + scale + " for " + singleImage.data[1] + " " + singleImage.data[2]);
                break;

        }

        //console.log('scaling... -> ' + version);



    }

    function collapsOnGroup(currentGroup, indexCurrentGroup, groupList) {
        var collaps = false;
        groupList.forEach(function(singleGroup, index) {

            if (index == indexCurrentGroup) return;

            if (!singleGroup.cordinate.x) return;

            //console.log('..With  ' + singleImage.data[0]);

            // let a = currentImage.cordinate;
            // let b = singleImage.cordinate;

            //console.log(currentImage.cordinate);
            // var c =  (
            //     a.p1.x <= b.p1.x && b.p1.x <= a.p2.x && a.p1.y <= b.p1.y && b.p1.y <= a.p2.y ||
            //     a.p1.x <= b.p2.x && b.p2.x <= a.p2.x && a.p1.y <= b.p2.y && b.p2.y <= a.p2.y ||
            //     a.p1.x <= b.p2.x && b.p2.x <= a.p2.x && a.p1.y <= b.p1.y && b.p1.y <= a.p2.y ||
            //     a.p1.x <= b.p1.x && b.p1.x <= a.p2.x && a.p1.y <= b.p2.y && b.p2.y <= a.p2.y
            // );
            // var c =  (
            //     a.p1.x <= b.p1.x && b.p1.x <= a.p2.x && a.p1.y <= b.p1.y && b.p1.y <= a.p2.y ||
            //     a.p1.x <= b.p2.x && b.p2.x <= a.p2.x && a.p1.y <= b.p2.y && b.p2.y <= a.p2.y ||
            //     a.p1.x <= b.p2.x && b.p2.x <= a.p2.x && a.p1.y <= b.p1.y && b.p1.y <= a.p2.y ||
            //     a.p1.x <= b.p1.x && b.p1.x <= a.p2.x && a.p1.y <= b.p2.y && b.p2.y <= a.p2.y ||
            //     a.p1.x <= b.p1.x && b.p1.x <= a.p2.x && a.p1.y <= b.p2.y && b.p2.y >= a.p2.y ||
            //     a.p1.x <= b.p1.x && b.p1.x <= a.p2.x && b.p1.y <= a.p2.y && a.p2.y >= b.p2.y

            // );
            //
            //

            // var c =  ( 
            //     a.p1.x > b.p1.x && a.p1.x < b.p2.x && a.p1.y > b.p1.y && a.p1.y < b.p2.y || 
            //     a.p2.x > b.p1.x && a.p2.x < b.p2.x && a.p2.y > b.p1.y && a.p2.y < b.p2.y ||
            //     a.p2.x > b.p1.x && a.p2.x < b.p2.x && a.p1.y < b.p1.y && a.p2.y > b.p2.y ||
            //     a.p1.y > b.p1.y && a.p1.y < b.p2.y && a.p1.x < b.p1.x && a.p2.x > b.p2.x
            //  );

            var a = currentGroup.cordinate.x - singleGroup.cordinate.x;
            var b = currentGroup.cordinate.y - singleGroup.cordinate.y;
            var c = Math.sqrt(a * a + b * b);

            c = c * 1.2; // TRUCCO!

            //console.log('Distance: ' + c);
            var radiusA = calculateCircumscribedRadius(singleGroup.cordinate.w, singleGroup.cordinate.h);
            var radiusB = calculateCircumscribedRadius(currentGroup.cordinate.w, currentGroup.cordinate.h);
            //console.log('Radius A: ' + radiusA);
            //console.log('Radius B: ' + radiusB);

            if ((radiusA + radiusB) > c) collaps = true;

            //console.log(collaps);



        });
        return collaps;

    }


    function collapsOn(currentImage, indexCurrentImage, imageList) {
        var collaps = false;
        //console.log('Checking collaps for ' + currentImage.data[0] + " with " + imageList.length + " elements");
        imageList.forEach(function(singleImage, index) {

            if (index == indexCurrentImage) return;
            if (!singleImage.cordinate.x) return;

            //console.log('..With  ' + singleImage.data[0]);

            // let a = currentImage.cordinate;
            // let b = singleImage.cordinate;

            //console.log(currentImage.cordinate);
            // var c =  (
            //     a.p1.x <= b.p1.x && b.p1.x <= a.p2.x && a.p1.y <= b.p1.y && b.p1.y <= a.p2.y ||
            //     a.p1.x <= b.p2.x && b.p2.x <= a.p2.x && a.p1.y <= b.p2.y && b.p2.y <= a.p2.y ||
            //     a.p1.x <= b.p2.x && b.p2.x <= a.p2.x && a.p1.y <= b.p1.y && b.p1.y <= a.p2.y ||
            //     a.p1.x <= b.p1.x && b.p1.x <= a.p2.x && a.p1.y <= b.p2.y && b.p2.y <= a.p2.y
            // );
            // var c =  (
            //     a.p1.x <= b.p1.x && b.p1.x <= a.p2.x && a.p1.y <= b.p1.y && b.p1.y <= a.p2.y ||
            //     a.p1.x <= b.p2.x && b.p2.x <= a.p2.x && a.p1.y <= b.p2.y && b.p2.y <= a.p2.y ||
            //     a.p1.x <= b.p2.x && b.p2.x <= a.p2.x && a.p1.y <= b.p1.y && b.p1.y <= a.p2.y ||
            //     a.p1.x <= b.p1.x && b.p1.x <= a.p2.x && a.p1.y <= b.p2.y && b.p2.y <= a.p2.y ||
            //     a.p1.x <= b.p1.x && b.p1.x <= a.p2.x && a.p1.y <= b.p2.y && b.p2.y >= a.p2.y ||
            //     a.p1.x <= b.p1.x && b.p1.x <= a.p2.x && b.p1.y <= a.p2.y && a.p2.y >= b.p2.y

            // );
            //
            //

            // var c =  ( 
            //     a.p1.x > b.p1.x && a.p1.x < b.p2.x && a.p1.y > b.p1.y && a.p1.y < b.p2.y || 
            //     a.p2.x > b.p1.x && a.p2.x < b.p2.x && a.p2.y > b.p1.y && a.p2.y < b.p2.y ||
            //     a.p2.x > b.p1.x && a.p2.x < b.p2.x && a.p1.y < b.p1.y && a.p2.y > b.p2.y ||
            //     a.p1.y > b.p1.y && a.p1.y < b.p2.y && a.p1.x < b.p1.x && a.p2.x > b.p2.x
            //  );

            var a = currentImage.cordinate.x - singleImage.cordinate.x;
            var b = currentImage.cordinate.y - singleImage.cordinate.y;
            var c = Math.sqrt(a * a + b * b);

            c = c * 1.2; // TRUCCO!

            //console.log('Distance: ' + c);
            var radiusA = calculateCircumscribedRadius(singleImage.data[1], singleImage.data[2]);
            var radiusB = calculateCircumscribedRadius(currentImage.data[1], currentImage.data[2]);
            //console.log('Radius A: ' + radiusA);
            //console.log('Radius B: ' + radiusB);

            if ((radiusA + radiusB) > c) collaps = true;

            //console.log(collaps);



        });
        return collaps;

    }

    function getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min; //Il max è escluso e il min è incluso
    }
    function calculateCircumscribedRadius(w, h) {
        return Math.floor(Math.hypot((w / 2), (h / 2)));
    }

    function degrees_to_radians(degrees) {
        return degrees * (Math.PI / 180);
    }

    function evaluateCollision(imageList) {

    }

    function getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min; //Il max è escluso e il min è incluso
    }

    function convertCordinate(pixel) {
        return Math.floor((500 * pixel) / 3000);
    }


    function plotOnMap(groupList) {

        var coreExtent = [-300, -300, 300, 300];
        var mapExtent = [-1000, -1000, 1000, 1000];

        var coreProjection = new Projection({
            code: 'ghk-image',
            units: 'cm',
            extent: coreExtent,
        });

        var minZoom = 0;
        var maxZoom = 5;

        var projectView = new View({
            center: getCenter(coreExtent),
            zoom: 0,
            maxZoom: maxZoom,
            minZoom: minZoom,
            projection: coreProjection,
            extent: mapExtent,
        });


        var projectMap = new Map({
            target: 'homePresentationGrid',
            view: projectView,
           
            //controls: defaultControls().extend([new FullScreen(), new NextWaypointControl(), new PrevWaypointControl()]),
            controls : defaultControls({
                attribution : false,
                zoom : false,
                rotate: false,
                shiftDragZoom: false
            }),
            interactions: defaultInteractions({altShiftDragRotate: false, pinchRotate: false}),

        });


        groupList.forEach(function(singleGroup, index) {
            singleGroup.images.forEach(function(singleImage, index) {


                projectMap.addLayer(
                    
                    new ImageLayer({
                        preload: Infinity,
                        source: new Static({
                            attributions: '© GHK',
                            url: singleImage.data[0],
                            projection: coreProjection,
                            imageExtent: singleImage.cordinate.extent,
                        }),
                    })
                );


            });
        });
        let randInt = getRandomInt(0, groupList.length);
        let randCenterGroup = groupList[randInt];
        let randExtent = [randCenterGroup.cordinate.maxBottom, randCenterGroup.cordinate.maxLeft, randCenterGroup.cordinate.maxRight, randCenterGroup.cordinate.maxTop];
        let randCenter = getCenter(randExtent);
        projectMap.getView().setCenter(randCenter);

        // projectMap.on('click', function(event) {
        //     console.log(event);
        //     projectMap.forEachFeatureAtPixel(event.pixel, function(feature, layer) {
        //         console.log(feature);
        //         console.log(layer);
        //         // if ( feature.getId() == "IND" ) {
        //         //         feature.setStyle(listenerStyle);
        //         //         featureListener(event);
        //         // }
        //     });
        // });

        projectView.fit(coreExtent);

        var mapMinX = 0, mapMaxX = 0, mapMinY = 0, mapMaxY = 0;

        groupList.forEach(function(group, index) {

            console.log(group.cordinate.maxLeft, group.cordinate.maxRight, group.cordinate.maxTop, group.cordinate.maxBottom);
            if (group.cordinate.maxLeft < mapMinX) mapMinX = group.cordinate.maxLeft;
            if (group.cordinate.maxRight > mapMaxX) mapMaxX = group.cordinate.maxRight;
            if (group.cordinate.maxTop < mapMinY) mapMinY = group.cordinate.maxTop;
            if (group.cordinate.maxBottom > mapMaxY) mapMaxY = group.cordinate.maxBottom;
        });

        console.log(mapMinX, mapMaxX, mapMinY, mapMaxY);

        var finalExtent = [mapMinX * 1.5,mapMinY *1.5, mapMaxX*1.5, mapMaxY*1.5];
        projectView.setProperties('extent', finalExtent);




        projectMap.on('singleclick', function(evt) {
            //console.log(evt);
            //console.log(evt.coordinate);
            // console.log(evt.coordinate()); 

            groupList.forEach(function(singleGroup, index) {
                singleGroup.images.forEach(function(singleImage, index) {

                    // console.log(singleImage.cordinate);
                    // console.log( singleImage.data[0] );
                    // let imagePoint = {
                    //     x1 : 
                    //     y1 : 
                    //     x2 : 
                    //     y2 :
                    // }

                    
                    if( pointInRect( singleImage.cordinate.extent , evt.coordinate) ){
                        //console.log('Inside!');
                        //console.log(singleImage);
                        if(singleImage.project.length > 0) {
                            window.location.href = singleImage.project;
                        } else return false;
                    }
                    


                });
            });
        });

        projectMap.on('pointermove', function(evt) {
            //console.log(evt);
            //console.log(evt.coordinate);
            // console.log(evt.coordinate()); 
            var projectFound = false;
            var isActuallyAProject = false;

            groupList.forEach(function(singleGroup, index) {
                singleGroup.images.forEach(function(singleImage, index) {

                    // console.log(singleImage.cordinate);
                    // console.log( singleImage.data[0] );
                    // let imagePoint = {
                    //     x1 : 
                    //     y1 : 
                    //     x2 : 
                    //     y2 :
                    // }

                    
                    if( pointInRect( singleImage.cordinate.extent, evt.coordinate) ){
                        //console.log('Inside!');
                        //console.log(singleImage);
                        jQuery('#projectTooltip').find('.projectTitle').text(singleImage.projectTitle);
                        jQuery('#projectTooltip').find('.projectLabel').text(singleImage.projectLabel);
                        projectFound = true; 
                        if(singleImage.project.length > 0 ) {
                            isActuallyAProject = true;
                        }
                        
                    } 
                    


                });
            });

            if(isActuallyAProject) {
                jQuery('#projectTooltip').removeClass('inactive-project');
            } else {
                jQuery('#projectTooltip').addClass('inactive-project');
            }

            if(projectFound) {
                jQuery('#projectTooltip').css('top', evt.originalEvent.pageY + 5);
                jQuery('#projectTooltip').css('left', evt.originalEvent.pageX + 5);
                jQuery('#projectTooltip').fadeIn(100);
            } else {
                jQuery('#projectTooltip').fadeOut(100);
            }

        });

        const pointInRect = function( pointList , point ){
            // console.log(pointList);
            // console.log(point);
            return (point[0] > pointList[0] && point[0] < pointList[2]) && (point[1] > pointList[1] && point[1] < pointList[3]);
        }


    }


});